import PeriodTranslation from 'src/models/period/interfaces/PeriodTranslation'
import DynamicTranslation from 'src/models/period/Translation/DynamicTranslation'
import { Locales } from 'src/i18n'

export default class DynamicTranslatable implements PeriodTranslation {
  key: string
  translations: { [locale: string]: DynamicTranslation }

  constructor(
    key: string,
    translations: { [locale: string]: DynamicTranslation },
  ) {
    this.key = key
    this.translations = translations
  }

  findTranslationByLocale(locale: Locales): DynamicTranslation | null {
    return this.translations[locale] ?? null
  }

  translate(locale: Locales, fallbackLocale: Locales) {
    let translation = this.findTranslationByLocale(locale)

    if (!translation) {
      translation = this.findTranslationByLocale(fallbackLocale)
    }

    return translation
  }
}
